var styles = {
  "unit-base": "4"
};

var UNIT = Number(styles['unit-base']);
var unit = function unit(modifier) {
  return modifier * UNIT;
};
var spacing = {
  xSmall: unit(0.5),
  small: unit(1),
  regular: unit(2),
  medium: unit(3),
  large: unit(4),
  xLarge: unit(6),
  x2Large: unit(8),
  x3Large: unit(12),
  x4Large: unit(16),
  x5Large: unit(24),
  x6Large: unit(32),
  Spacer50: unit(0.5),
  Spacer100: unit(1),
  Spacer150: unit(1.5),
  Spacer200: unit(2),
  Spacer300: unit(3),
  Spacer400: unit(4),
  Spacer500: unit(5),
  Spacer600: unit(6),
  Spacer700: unit(7),
  Spacer800: unit(8),
  Spacer900: unit(9),
  Spacer1000: unit(10),
  Spacer1100: unit(11),
  Spacer1200: unit(12),
  Spacer1400: unit(14),
  Spacer1600: unit(16),
  Spacer2400: unit(24),
  Spacer3200: unit(32)
};
/** @deprecated Use `spacing.*` keys instead (e.g. `spacing.medium`) */
var Spacing = {
  XSmall: spacing.xSmall,
  Small: spacing.small,
  Regular: spacing.regular,
  Medium: spacing.medium,
  Large: spacing.large,
  XLarge: spacing.xLarge,
  X2Large: spacing.x2Large,
  X3Large: spacing.x3Large,
  X4Large: spacing.x4Large,
  X5Large: spacing.x5Large,
  X6Large: spacing.x6Large,
  Spacer50: spacing.Spacer50,
  Spacer100: spacing.Spacer100,
  Spacer150: spacing.Spacer150,
  Spacer200: spacing.Spacer200,
  Spacer300: spacing.Spacer300,
  Spacer400: spacing.Spacer400,
  Spacer500: spacing.Spacer500,
  Spacer600: spacing.Spacer600,
  Spacer700: spacing.Spacer700,
  Spacer800: spacing.Spacer800,
  Spacer900: spacing.Spacer900,
  Spacer1000: spacing.Spacer1000,
  Spacer1100: spacing.Spacer1100,
  Spacer1200: spacing.Spacer1200,
  Spacer1400: spacing.Spacer1400,
  Spacer1600: spacing.Spacer1600,
  Spacer2400: spacing.Spacer2400,
  Spacer3200: spacing.Spacer3200
};

export { Spacing, spacing, unit };
//# sourceMappingURL=spacing.js.map
